import styles from "./SurveyHeader.module.scss";

import { useTranslation } from "react-i18next";

import { Logo } from "@/modules/shared/components/Logo";
import { CoachAvatarFallbackSvg } from "@/modules/shared/svgs/CoachAvatarFallbackSvg";

interface SurveyHeaderProps {
  coachName: string;
  sessionDate: string;
  coachPhotoUrl?: string;
}

export function SurveyHeader({
  coachName,
  sessionDate,
  coachPhotoUrl,
}: SurveyHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <Logo size="compact" />

      <div className={styles.session}>
        <h1 className={styles.title}>{t("sessionSurvey.header.title")}</h1>

        <div className={styles.coach}>
          <span className={styles.avatar}>
            {coachPhotoUrl ? (
              <img
                className={styles.avatarImage}
                src={coachPhotoUrl}
                alt={coachName}
              />
            ) : (
              <CoachAvatarFallbackSvg
                className={styles.avatarFallback}
                data-testid="coach-avatar-fallback"
              />
            )}
          </span>
          <p className={styles.coachText}>{coachName}</p>
          {sessionDate ? (
            <>
              <span className={styles.coachText} aria-hidden>
                •
              </span>
              <p className={styles.coachText}>{sessionDate}</p>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
